import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule as ProgetSharedCommonModule } from '@proget-shared';
import { InputModule } from '@proget-shared/form/input';
import { TranslateModule } from '@proget-shared/translate';
import { LinkModule } from '@proget-shared/ui/link';
import { ShortcutModule } from '@proget-shared/ui/shortcut';
import { SpinnerModule } from '@proget-shared/ui/spinner';

import { SearcherAutocompleteComponent } from './component/searcher-autocomplete/searcher-autocomplete.component';

@NgModule({
  declarations: [SearcherAutocompleteComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    InputModule,
    SpinnerModule,
    LinkModule,
    ProgetSharedCommonModule,
    ShortcutModule,
  ],
  exports: [SearcherAutocompleteComponent],
})
export class SearcherModule {}
